import { render } from "./ImageTextCarousel.vue?vue&type=template&id=680a361e&scoped=true"
import script from "./ImageTextCarousel.vue?vue&type=script&lang=js"
export * from "./ImageTextCarousel.vue?vue&type=script&lang=js"

import "./ImageTextCarousel.vue?vue&type=style&index=0&id=680a361e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-680a361e"]])

export default __exports__